import { change } from 'redux-form';
import { replace } from 'react-router-redux';

import { error, loading, success, handleErrorException } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { FilterEnum, AdjustmentEnum } from 'Common/FieldEnum';
import { CREATE_EDIT_ADJUSTMENT_FORM_NAME } from 'Common/FormEnum';

import * as types from './types';

export const getAdjustmentDetail = adjustmentID => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_ADJUSTMENT_DETAIL, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Adjustment/GetAdjustmentDetails/${adjustmentID}`
      );
      dispatch(
        success(
          types.SELECTED_ADJUSTMENT_DETAIL,
          response.data.Data[AdjustmentEnum.AdjustmentSummary]
        )
      );
      dispatch(
        success(
          types.VIEW_ADJUSTMENT_ITEMS,
          response.data.Data[AdjustmentEnum.AdjustmentItems]
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: AdjustmentEnum.Error,
        Message:
          'An error occurred while fetching Adjustment Detail. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_ADJUSTMENT_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_ADJUSTMENT_DETAIL, false));
    }
  };
};

export const getAdjustmentItems = fetchData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ADJUSTMENT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Adjustment/GetAdjustmentItems',
        fetchData
      );
      dispatch(
        success(
          types.CREATE_EDIT_ADJUSTMENT_ITEMS,
          response.data.Data[AdjustmentEnum.AdjustmentItems]
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: AdjustmentEnum.Error,
        Message:
          'An error occurred while fetching Adjustment Items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ADJUSTMENT_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ADJUSTMENT_LOADING, false));
    }
  };
};

export const clearInvalidPreviewData = data => {
  return async dispatch => {
    dispatch(
      change(
        CREATE_EDIT_ADJUSTMENT_FORM_NAME,
        AdjustmentEnum.AdjustmentItemsInfo,
        data
      )
    );
  };
};

export const resetFilterOnClickOfPreviousPage = () => {
  return dispatch => {
    dispatch(
      change(CREATE_EDIT_ADJUSTMENT_FORM_NAME, [FilterEnum.GroupId_Bid], 0)
    );
    dispatch(
      change(CREATE_EDIT_ADJUSTMENT_FORM_NAME, [FilterEnum.GroupId_Item], 0)
    );
  };
};

export const emptyItemList = () => {
  return {
    type: types.CREATE_EDIT_ADJUSTMENT_ITEMS,
    payload: [],
  };
};

export const saveAdjustment = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_ADJUSTMENT_DETAIL, true));
    resetScroll();
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Adjustment/SaveAdjustment',
        model
      );
      dispatch(resetDirty());
      if (response.data.Data.Status === AdjustmentEnum.Error) {
        dispatch(
          error(types.SUBMIT_ADJUSTMENT_DETAIL_ERROR, response.data.Data)
        );
      } else {
        dispatch(success(types.ADJUSTMENT_DETAIL_SUBMIT));
        dispatch(replace('/adjustment'));
      }
    } catch (ex) {
      const defaultError = {
        Title: AdjustmentEnum.Error,
        Message: 'An error occurred while saving Adjustment. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SUBMIT_ADJUSTMENT_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_ADJUSTMENT_DETAIL, false));
    }
  };
};

export const clearOrderSubmitError = () => {
  return {
    type: types.CLEAR_ADJUSTMENT_ERROR_SUCCESS,
  };
};

export const emptyEditDulObject = () => {
  return {
    type: types.SELECTED_ADJUSTMENT_DETAIL,
    payload: null,
  };
};

export const clearAdjustmentItemGridData = () => {
  return change(
    CREATE_EDIT_ADJUSTMENT_FORM_NAME,
    AdjustmentEnum.AdjustmentItemsInfo,
    []
  );
};

export const setModifiedAdjustmentItems = data => {
  return change(
    CREATE_EDIT_ADJUSTMENT_FORM_NAME,
    AdjustmentEnum.AdjustmentItemsInfo,
    data
  );
};

export const reorderItemList = items => {
  return {
    type: types.RE_ADJUSTMENT_ITEM_LIST,
    payload: items,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/createEditAdjustment/actions.js